import type { ThemeSettings } from '../runtime/services/CmsSettingsService';

export default defineNuxtPlugin({
    name: 'cms',
    dependsOn: ['axios'],
    async setup(nuxtApp)
    {
        const store = useComponentsStore();
        const app = useNuxtApp();

        // Module settings
        const requireModuleComponent = import.meta.glob('~~/**/_partials/module/*Settings.vue');

        Object.entries(requireModuleComponent).forEach(([key, component]: [string, any]) =>
        {
            const name = `CmsModule${key.split('/').last().replace('.vue', '')}`;

            store.modules.push(name);
            app.vueApp.component(name, defineAsyncComponent(component));
        });

        // Widget settings
        const requireWidgetComponent = import.meta.glob('~~/**/app/components/widget/**/*Settings.vue');

        Object.entries(requireWidgetComponent).forEach(([key, component]: [string, any]) =>
        {
            const name = `CmsWidget${key.split('/').last().replace('.vue', '')}`;

            store.widgets.push(name);
            app.vueApp.component(name, defineAsyncComponent(component));
        });

        return {
            provide: {
                theme: (name: string, throwError: boolean = false): Promise<ThemeSettings> =>
                {
                    return useSettingsStore().$theme(name, throwError);
                }
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $theme(name: string, throwError?: boolean): Promise<ThemeSettings>;
    }
}
